import React, { useEffect, useState, createContext } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useLocation } from "react-router-dom";
import SearchStringOrIntReq5 from "../../../Classes/Models/Requests/SearchStringOrIntReq";
import AccountingApi from "../../../Classes/API/AccountingApi";
import ContractDetailsCard from "./ContractDetailsCard";
import AddPatients from "./AddPatients";
import PatientsTable from "./PatientsTable";
import ContractSessionsTable from "./ContractSessionsTable";
import UnlinkedSessionsTable from "./UnlinkedSessionsTable";
import SearchStringOrIntReq from "../../../Classes/Models/Requests/SearchStringOrIntReq";

const index = () => {
  let { state } = useLocation();

  const [IsLoaded, setIsLoaded] = useState(false);
  const [Contract, setContract] = useState({});
  const [ShowSessions, setShowSessions] = useState(false);
  const [ShowAddPatients, setShowAddPatients] = useState(false);

  const GetContractData = async (id) => {
    let req = new SearchStringOrIntReq5();
    req.SearchInt = id;
    let res = await AccountingApi.GetContractById(req);
    if (res.status == "Success") {
      setContract(res.data);
    }
  };

  useEffect(async () => {
    if (!IsLoaded) {
      await GetContractData(state.SearchContract.id);
    }
  }, [IsLoaded]);

  useEffect(() => {
    if (Object.keys(Contract).length > 0) {
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
    }
  }, [Contract]);

  const GetPatientComponents = () => {
    return (
      <>
        <AddPatients Contract={Contract} setIsLoaded={setIsLoaded} />
        <PatientsTable Contract={Contract} setIsLoaded={setIsLoaded} />
      </>
    );
  };

  if (!IsLoaded) {
    return <div>Loading Contract Data...</div>;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ContractDetailsCard
        Contract={Contract}
        setShowAddPatients={setShowAddPatients}
        ShowAddPatients={ShowAddPatients}
        setShowSessions={setShowSessions}
        ShowSessions={ShowSessions}
      />

      {ShowAddPatients && GetPatientComponents()}
      {ShowSessions && <ContractSessionsTable Contract={Contract} setIsLoaded={setIsLoaded} />}

      <UnlinkedSessionsTable Contract={Contract} setIsLoaded={setIsLoaded} />
    </DashboardLayout>
  );
};

export default index;
